import { render } from "./BillDetailsModal.vue?vue&type=template&id=eb6d0f62"
import script from "./BillDetailsModal.vue?vue&type=script&lang=js"
export * from "./BillDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__